module.exports = __webpack_public_path__ + "static/media/icon_check.c6d7ddfc.svg";